import { _ } from "js/vendor";
import { Component } from "reactn";
import React from "reactn";
import { Button, IconButton, Menu } from "@material-ui/core";
import { Fragment } from "react";
import Icon from "./Icon";
import Spinner from "./Spinner";
import { Gap10, Gap20 } from "js/react/components/Gap";

export class List extends Component {
    state = {
        sort: null,
        sortAscending: true
    };

    handleSortData = sort => {
        this.setState({
            sort: sort,
            sortAscending: !this.state.sortAscending
        });
    };

    render() {
        let { data, showHeader, isLoading, onClickRow, onDoubleClickRow } = this.props;
        let { sort, sortAscending } = this.state;

        if (sort) {
            data = _.sortBy(data, row => typeof row[sort] === "string" ? row[sort].toLowerCase() : row[sort]);
            if (!sortAscending) {
                data = data.reverse();
            }
        }

        let gridTemplateColumns = this.props.children
            .map(field => {
                if (!field) return;
                if (field.props.width == null) {
                    if (field.type.name == "ListContextMenu") {
                        return "50px";
                    } else {
                        return "1fr";
                    }
                }
                if (isNaN(field.props.width)) {
                    return field.props.width;
                } else {
                    return field.props.width + "px";
                }
            })
            .join(" ");

        let renderList = () => {
            if (isLoading) {
                return <Spinner />;
            }
            if (data) {
                return data.map(row => (
                    <ListRow
                        key={row.id || _.uniqueId()}
                        data={row}
                        fields={this.props.children}
                        columns={gridTemplateColumns}
                        onClick={() => onClickRow && onClickRow(row)}
                        onDoubleClick={() => onDoubleClickRow && onDoubleClickRow(row)}
                    />
                ));
            } else {
                return "No items";
            }
        };

        return (
            <div className="beautiful-list">
                {showHeader ? (
                    <ListHeader
                        onSort={this.handleSortData}
                        sortField={sort}
                        sortAscending={sortAscending}
                        columns={gridTemplateColumns}
                        fields={this.props.children}
                    />
                ) : null}
                {renderList()}
            </div>
        );
    }
}

export class ListHeader extends Component {
    render() {
        let { fields, sortField, columns } = this.props;

        let dataFields = fields.map(field => {
            if (!field) return;
            return React.createElement(ListFieldHeader, {
                key: field.props.field || _.uniqueId(),
                ...field.props,
                onSort: this.props.onSort,
                isSorted: sortField == field.props.field,
                sortAscending: this.props.sortAscending
            });
        });

        return (
            <div className="list-header" style={{ gridTemplateColumns: columns }}>
                {dataFields}
            </div>
        );
    }
}

class ListFieldHeader extends Component {
    render() {
        let { name, field, width, sortable, onSort, isSorted, sortAscending, isSelectField } = this.props;

        let sortIndicator;
        if (sortable && isSorted) {
            sortIndicator = <i className="sort-indicator micon">{sortAscending ? "arrow_downwards" : "arrow_upwards"}</i>;
        }

        return (
            <div
                onClick={sortable ? () => onSort(field) : null}
                key={name || _.uniqueId()}
                className="list-field-header"
            >
                {isSelectField && <Gap20 />}
                {name}
                {sortIndicator}
            </div>
        );
    }
}

export class ListRow extends Component {
    render() {
        let { data, fields, columns, onClick, onDoubleClick } = this.props;

        let dataFields = fields.map(field => {
            if (!field) return;
            return React.cloneElement(field, {
                key: field.props.field || _.uniqueId(),
                data: data
            });
        });

        return (
            <div key={data.id || _.uniqueId()} className="list-item" style={{ gridTemplateColumns: columns }} onClick={onClick} onDoubleClick={onDoubleClick}>
                {dataFields}
            </div>
        );
    }
}

export class ListField extends Component {
    render() {
        let { field, type, width, data, renderer } = this.props;

        let fieldClass = `${field} list-field`;
        switch (type) {
            case "bold":
                fieldClass += " bold";
                break;
            case "tag":
                fieldClass += " label";
                break;
        }

        return <div className={fieldClass}>{renderer ? renderer(data) : data[field] ? data[field] : "--"}</div>;
    }
}

export class ListAction extends Component {
    render() {
        let { data, callback, renderer, onClick } = this.props;

        if (renderer) {
            return renderer(data);
        }

        return (
            <Button color="primary" size="small" variant="contained" onClick={() => callback(data)} rowid={data.id}>
                {this.props.children}
            </Button>
        );
    }
}

export class ListIcon extends Component {
    render() {
        let { data, callback, renderer, onClick, iconName } = this.props;

        if (renderer) {
            return renderer(data);
        }

        return <Icon iconName={iconName} onClick={onClick} />;
    }
}

export class ListImage extends Component {
    render() {
        let { data } = this.props;

        return <img src={data.imageURL} />;
    }
}

export class ListContextMenu extends Component {
    state = {
        menuAnchorEl: null
    };

    render() {
        let { menuAnchorEl } = this.state;
        let { data, callback, renderer, showOnHover } = this.props;

        let menuItemsDef;

        if (renderer) {
            menuItemsDef = renderer(data);
        } else {
            menuItemsDef = this.props.children;
        }

        if (!menuItemsDef) {
            return null;
        }

        let menuItems = menuItemsDef.map(menuItem => {
            return React.cloneElement(menuItem, {
                rowid: data.id,
                onClick: () => {
                    this.setState({ menuAnchorEl: null });
                    menuItem.props.onClick(data);
                }
            });
        });

        return (
            <Fragment>
                <IconButton
                    disableRipple
                    className={`list-item-icon-button ${showOnHover ? "show-on-hover" : ""}`}
                    onClick={event => this.setState({ menuAnchorEl: event.currentTarget })}
                >
                    <Icon iconName="more_vert" />
                </IconButton>
                <Menu
                    id="list-context-menu"
                    anchorEl={menuAnchorEl}
                    open={Boolean(menuAnchorEl)}
                    onClose={() => this.setState({ menuAnchorEl: null })}
                >
                    {menuItems}
                </Menu>
            </Fragment>
        );
    }
}
